import React from 'react'

const FormProvider = React.createContext(false)

export default FormProvider